//module.exports.VerticalSelection = require("./vertical_selection")
//module.exports.HorizontalSelection = require("./horizontal_selection")
//module.exports.RegionSelect = require("./region_select")
//module.exports.PositionSelect = require("./position_selection")
export {SelectionManager} from "./SelectionCol";
//module.exports.SelectionList = require("./selectionlist")
//module.exports.RectangularSelect = require("./rectangular_select")



/** WEBPACK FOOTER **
 ** ./src/g/selection/index.js
 **/